const ITEMS = ["Building Businesses", "Connecting Markets", "Creating Impact", "India", "UAE", "Nepal", "Global", "Aviation", "Railways", "Healthcare", "Agriculture", "Climate Tech", "Capital", "People", "Opportunity"];

const Marquee = () => (
  <div className="relative bg-gradient-to-r from-[#D9A85C] via-[#E9C88A] to-[#D9A85C] py-4 overflow-hidden" data-testid="editorial-marquee">
    <div className="animate-marquee flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center">
          {ITEMS.map((item, i) => (
            <span key={`${copy}-${i}`} className="flex items-center">
              <span className={`font-display text-lg md:text-xl px-6 ${i % 3 === 0 ? "italic font-semibold text-[#0A0D14]" : "text-[#0A0D14]/70"}`}>{item}</span>
              <span className="h-1.5 w-1.5 rotate-45 bg-[#0A0D14]/50" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
